import { STATUS_TONES } from "@/components/ui/tone-classes"
import { cn } from "@/lib/utils"

/** Shared layout/styling for “rendered vs original” preview notices (converted file + approximate highlight). */
export const renderedPreviewBannerClassName = cn(
  "mb-4 flex gap-2 rounded-md px-3 py-2 text-xs leading-snug",
  STATUS_TONES.info.soft
)

export const renderedPreviewBannerIconClassName = "size-4 shrink-0 text-primary"
